/**
 * Detect given resource view/edit/publish privileges by Group, based on user Memberships.
 */
import { isProdSite, isTestEnv } from '@/helpers/deployment';

export default {

    data: function () {
        return {
            canRead: false,
            canEdit: false,
            canPublish: false
        };
    },

    methods: {

        revokeAccess: function () {
            this.canRead = false;
            this.canEdit = false;
            this.canPublish = false;
        },

        /**
         * Detect Read, Edit, Publish Access privileges.
         */
        getAccessPrivileges: function (resource) {
            // create mode
            if (resource && resource.Id === '0') {
                this.canRead = true;
                this.canEdit = true;
                this.canPublish = true; // perhaps context-aware publish access?

                // hide edit toggle
                this.$eventBus.$emit('page-access-change', true, null, true);
            }
            // resource with Access
            else if (resource && resource.Access) {
                this.getReadAccess(resource);
                this.getEditAccess(resource);
                this.getPublishAccess(resource);
            }
            // no Access to resource or no resource at all
            else {
                // no privileges
                this.revokeAccess();
            }

            // resource might be Derived, and may not be available to edit even if the original is
            if (!this.canEdit && resource && resource.Publish && resource.Publish.IsDerived &&
                this.$store.getters['user/getMembershipLevel'] >= 9000) {

                console.info("Edit access is forbidden, but page is Derived. Try editing in original language.");
                this.$eventBus.$emit('page-access-change', false, this.$t('common.editNotAllowedOnDerived'));
            }
            else if (!this.canEdit && resource) {
                // emit signal to "pencil" to disable itself if editing is not possible
                this.$eventBus.$emit('page-access-change', false);
            }
        },

        /**
         * Return Access params for edit component.
         * Used to set FeatureArticles and Events ReadAccess.
         */
        getAccessGroups: function (resource) {
            const groups = {
                ReadAccess: this.getReadAccessGroupName(resource)
            };
            return groups;
        },

        /**
         * Return the resource's ReadAccess group from stored User Profile.
         * Returns name, or Id if name is not found.
         */
        getReadAccessGroupName: function (resource) {
            const readGroupId = resource && resource.Access && resource.Access.ReadGroup; // Id
            const group = this.getUserGroup(readGroupId);
            return (group && group.GroupName) || readGroupId;
        },

        getReadAccess: function (resource) {
            if (resource && resource.Access) {
                const group = this.getUserGroup(resource.Access.ReadGroup);
                if (group) {
                    // this.logAccess("Read", resource, group.GroupDisplayName);
                    this.canRead = true;
                    return true;
                }
                else {
                    // this.logNoAccess("Read", resource);
                    this.canRead = true;
                    return false;
                }
            }
        },

        getEditAccess: function (resource) {
            if (resource && resource.Access) {
                const group = this.getUserGroup(resource.Access.EditGroup);
                if (group) {
                    this.logAccess("Edit", resource, group.GroupDisplayName);
                    this.canEdit = true;
                    this.$eventBus.$emit('page-access-change', true);
                    return true;
                }
                else {
                    // this.logNoAccess("Edit", resource);
                    this.canEdit = false;
                    return false;
                }
            }
            else if (resource) {
                // resource without Access
                this.$eventBus.$emit('page-access-change', false);
            }
            else {
                // no resource, hide edit mode toggle icon
                this.$eventBus.$emit('page-access-change', false, null, true);
            }
        },

        getPublishAccess: function (resource) {
            if (resource && resource.Access) {
                const group = this.getUserGroup(resource.Access.PublishGroup);
                if (group) {
                    this.logAccess("Publish", resource, group.GroupDisplayName);
                    this.canPublish = true;
                    return true;
                }
                else {
                    // this.logNoAccess("Publish", resource);
                    this.canPublish = false;
                    return false;
                }
            }
        },

        /**
         * Return group User has membership to.
         */
        getUserGroup: function (groupId) {
            const memberships = this.$store.getters['user/getMemberships'];
            return _.find(memberships, {GroupId: groupId});
        },

        logAccess: function (action, resource, groupDisplayName) {
            if (!isProdSite && !isTestEnv) {
                console.info(`${action} access to ${resource && resource.Name} granted through group ${groupDisplayName}`);
            }
        },

        logNoAccess: function (action, resource) {
            if (!isProdSite && !isTestEnv) {
                console.warn(`No ${action} access to ${resource && resource.Id} - ${resource && resource.Name}`);
            }
        }
    }
};
